import { loan_application } from '@axo/shared/data-access/types';
import { Icon, IconProps } from '@blueprintjs/core';
import { BlueprintIcons_16Id } from '@blueprintjs/icons/lib/esm/generated/16px/blueprint-icons-16';

export function getProductIcon(
  product?: loan_application.Product
): BlueprintIcons_16Id {
  if (!product) {
    return 'blank';
  }
  switch (product) {
    case loan_application.Product.CreditCard:
      return 'credit-card';
    case loan_application.Product.UnsecuredLoan:
      return 'dollar';
    case loan_application.Product.SecuredLoan:
      return 'home';
    default:
      return 'blank';
  }
}

export function ProductIcon({
  product,
  ...props
}: {
  product?: loan_application.Product;
} & Omit<IconProps, 'icon'>) {
  return <Icon {...props} icon={getProductIcon(product)} />;
}
